var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L20.516 17.705C20.175 19.612 18.516 21 16.579 21H7.422C5.485 21 3.826 19.612 3.485 17.705L3 15H5L5.568 17.451C5.778 18.358 6.585 19 7.516 19H16.484C17.415 19 18.222 18.358 18.432 17.451L19 15H21ZM17.414 10.414L16 9L13 12.129V3H11V12.129L8 9L6.586 10.414L12 16L17.414 10.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadM);
export default __webpack_public_path__ + "static/media/download-M.144f920a297517821083a50544235ae1.svg";
export { ForwardRef as ReactComponent };